import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';

const getFavouriteVenueOptions = async () => {
	const data = new FormData();
	data.append('action', 'get_favourite_venue_options');
	let res = 'api-fail';

	await fetch(igniteJsVars.ajaxurl, {
		method: 'POST',
		body: data,
	})
		.then((res) => res.json())
		.then((data) => {
			res = data;
		})
		.catch((err) => {
			console.error('Error: ', err);
		});

	return res;
};

const igniteAtreemoSignupForm = async () => {
	const formWrapper = document.querySelector('.atreemo-waitlist-form');
	if (formWrapper) {
		const form = formWrapper.querySelector('form');

		// Get locations for favourite venue dropdown
		const favouriteVenueField = formWrapper.querySelector('.js-atreemo-locations');
		const res = await getFavouriteVenueOptions();

		if (!res.Response) {
			// Locations werent retrieved.
			form.style.display = 'none';
			formWrapper.classList.remove('is-loading');
			formWrapper.querySelector('.m__atreemo__form-message__locations-not-found').style.display =
				'block';

			console.error(
				'Cannot connect with atreemo to retrieve locations for favourite venue field'
			);
			return false;
		} else {
			const brands = getLocationsSelectOptions(res.Locations);

            // Clear the loading locations message
			favouriteVenueField.innerHTML = '';

			Object.keys(brands).forEach((brand) => {
				// console.log(brand, brands[brand]);

				// Create optgroup for brand
				const optGroup = document.createElement('optgroup');
				optGroup.setAttribute('label', brand);
				favouriteVenueField.appendChild(optGroup);

				// Loop through brand's restaurants and create options for each
				brands[brand].forEach((restaurant) => {
					let option = document.createElement('option');
					option.value = restaurant.id;
					option.text = restaurant.name;
					option.setAttribute('data-venue-name', restaurant.name);
					optGroup.appendChild(option);
				});
			});
            
			formWrapper.classList.remove('is-loading');
            form.querySelector('.button').removeAttribute('disabled');
		}

		// Do internationalised mobile field
		const telInput = document.querySelector('#atreemo_mobile');
		const iti = intlTelInput(telInput, {
			utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@18.2.1/build/js/utils.js',
			autoInsertDialCode: true,
			initialCountry: 'gb',
			preferredCountries: ['gb'],
		});

		form.addEventListener('submit', (e) => {
			e.preventDefault();

			// Clear any exisitng error messages
			const erorrMessages = document.querySelectorAll('.js-atreemo-error-field.showing');
			if (erorrMessages) {
				erorrMessages.forEach((error) => {
					error.classList.remove('showing');
				});
			}

			let errorCount = 0;

			// Check if dob is over 18
			const dobField = document.getElementById('atreemo_dob');
			if (!checkOverEighteen(dobField.value) && dobField.hasAttribute('required')) {
				errorCount++;
				document.querySelector('.js-atreemo-error-field--date').classList.remove('hidden');
			}

			// Check if phone number if valid
			if (!iti.isValidNumber() && telInput.value != '') {
				errorCount++;
				document.querySelector('.js-atreemo-error-field--phone').classList.remove('hidden');
			}

			if (errorCount === 0) {
				// Loading state
				formWrapper.classList.add('is-loading');

				// Reset error messages
				formWrapper
					.querySelectorAll('.m__atreemo__form-message')
					.forEach((msg) => (msg.style.display = 'none'));

				const formData = new FormData(form);
				formData.append('action', 'process_atreemo_signup');

				// Append location name
				const venueName =
					favouriteVenueField.options[favouriteVenueField.selectedIndex].getAttribute(
						'data-venue-name'
					);
				formData.append('atreemo_venue_name', venueName);

				// Display the key/value pairs
				/* for (const pair of formData.entries()) {
					console.log(`${pair[0]}, ${pair[1]}`);
				} */

				fetch(igniteJsVars.ajaxurl, {
					method: 'POST',
					body: formData,
				})
					.then((res) => res.json())
					.then((data) => {
						// console.log(data);
						const res = data.atreemo_res;

						if (res.ResponseStatus) {
							form.style.display = 'none';
							if (!res.ResponseData.Duplicated) {
								// A new user in atreemo was created
								formWrapper.querySelector(
									'.m__atreemo__form-message__user-created'
								).style.display = 'block';
							} else {
								// User in atreemo was updated not created
								formWrapper.querySelector(
									'.m__atreemo__form-message__user-updated'
								).style.display = 'block';
							}
						} else {
							// Atreemo failed to create or update the user.
							console.error('Atreemo failed to create a customer: ', res);
							console.warn('Data posted: ', data.$_POST);

							formWrapper.querySelector(
								'.m__atreemo__form-message__failed'
							).style.display = 'block';
						}
					})
					.catch((err) => {
						console.error('Error: ', err);
					})
					.finally(() => {
						formWrapper.classList.remove('is-loading');
					});
			}
		});
	}
};

// Gets the select field's options
function getLocationsSelectOptions(locations) {
	const brands = {
		Piccolino: [],
		Piccolo: [],
		'Riva Blu': [],
		'Restaurant Bar & Grill': [],
	};

	// Group all restaurants by brand
	locations.forEach((loc) => {
		const name = loc.LocationName.toLowerCase();
		if (!name) return false;

		if (name.indexOf('piccolino') !== -1) {
			brands['Piccolino'].push({
				name: loc.LocationName,
				id: loc.LocationID,
			});
		} else if (name.indexOf('piccolo') !== -1) {
			brands['Piccolo'].push({
				name: loc.LocationName,
				id: loc.LocationID,
			});
		} else if (name.indexOf('riva') !== -1) {
			brands['Riva Blu'].push({
				name: loc.LocationName,
				id: loc.LocationID,
			});
		} else if (name.indexOf('restaurant bar & grill') !== -1) {
			brands['Restaurant Bar & Grill'].push({
				name: loc.LocationName,
				id: loc.LocationID,
			});
		} else if (name.indexOf('restaurant & bar') !== -1) {
			brands['Restaurant Bar & Grill'].push({
				name: loc.LocationName,
				id: loc.LocationID,
			});
		} else if (name.indexOf('marlow bar & grill') !== -1) {
			brands['Restaurant Bar & Grill'].push({
				name: loc.LocationName,
				id: loc.LocationID,
			});
		} else if (name.indexOf('opera grill') !== -1) {
			brands['Restaurant Bar & Grill'].push({
				name: loc.LocationName,
				id: loc.LocationID,
			});
		}
	});

	// Alphebatize restaurants within each brand
	Object.keys(brands).forEach((brand) => {
		brands[brand].sort((a, b) => a.name.localeCompare(b.name));
	});

	return brands;
}

function checkOverEighteen(dob) {
	// Create a Date object from the dob
	const inputDate = new Date(dob);

	// Calculate a date that is 18 years ago
	const eighteenYearsAgo = new Date();
	eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);

	// Compare the input date with the calculated date
	return inputDate <= eighteenYearsAgo;
}

document.addEventListener('DOMContentLoaded', function () {
	igniteAtreemoSignupForm();
});